export default "__VITE_ASSET__YcwO6plO__"